<template>
    <div>
        <modal :show.sync="openFCI" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Fuente Captura de Información</h6>  
                <div class="row">
                    <div v-if="pymeMessage != null" class="alert alert-info">
                        <span>El valor actual del sistema es:<strong> {{ pymeMessage }}</strong></span>
                    </div>  
                    <p-button @click="saveCostsPymeData('Estados financieros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cubes mr-3"></i>
                        Estados financieros
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Software contable')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Software contable
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Registros en excel')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Registros en excel
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Libros contables')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Libros contables
                    </p-button>
                </div>
                <div class="row">
                    <p-button @click="saveCostsPymeData('Otros')" type="block btn-warning">
                        <i slot="label" class="fa fa-cube mr-3"></i>
                        Otros
                    </p-button>
                </div>
                <template slot="footer">
                    <div class="left-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Cancelar</p-button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        <p-button type="default" link @click="cancelOpenFCI()">Aceptar</p-button>
                    </div>
                </template>       
        </modal>
        <!-- <p style="color:white;">{{this.products}}</p> -->
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar producto</h6>
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="productLineName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Promedio de compra</label>
                    <vue-numeric  :max=999999999999999 tabindex="1" currency="$" autocomplete="off" name="promedio de compra" v-validate="modelValidations.sales" :error="getError('promedio de compra')" separator="." class="form-control" v-model="productLinePurchaseCost"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Frecuencia mes</label>
                    <fg-input   tabindex="2"
                                type="number"
                                name="frecuencia mes"
                                placeholder="frecuencia de compra al mes"
                                autocomplete="off"
                                v-validate="modelValidations.monthly"
                                :error="getError('frecuencia mes')"
                                v-model="productLineMonthly">
                    </fg-input>
                </div>
                <div v-if="productLineTotal != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productLineTotal)}}</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="productLineTotal != 0" type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar ítem</h6>
                <div class="form-group">
                    <label>Ítem *</label>
                    <fg-input   tabindex="3"
                                type="text"
                                name="ítem"
                                placeholder="ítem"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('ítem')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de compra</label>
                    <vue-numeric  :max=999999999999999 tabindex="4" currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemPurchasePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Precio de venta</label>
                    <vue-numeric  :max=999999999999999 tabindex="5" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="itemSalePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>%</label>
                    <fg-input   type="number"
                                name="%"
                                disabled
                                placeholder="%"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :value="item_percent_computed"
                                :error="getError('%')"
                                v-model="itemPercent">
                    </fg-input>
                </div>
                <div v-if="item_prices_validate_computed == false" class="alert alert-danger">
                    <span>El precio de compra de un ítem no puede ser mayor al precio de venta</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="item_prices_validate_computed == true" type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar ítem</h6>
                <div class="form-group">
                    <label>Ítem *</label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="ítem"
                                placeholder="ítem"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('ítem')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de compra</label>
                    <vue-numeric  :max=999999999999999 tabindex="7" currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemPurchasePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Precio de venta</label>
                    <vue-numeric  :max=999999999999999 tabindex="8" currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="itemSalePrice"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>%</label>
                    <fg-input   type="number"
                                name="%"
                                disabled
                                placeholder="%"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :value="item_percent_computed"
                                :error="getError('%')"
                                v-model="itemPercent">
                    </fg-input>
                </div>
                <div v-if="item_prices_validate_computed == false" class="alert alert-danger">
                    <span>El precio de compra de un ítem no puede ser mayor al precio de venta</span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button v-if="item_prices_validate_computed == true" type="default" link @click="editItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <card v-if="switches.product" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Costeo por compras</h6>
                <p-button v-if="pequenia_empresa" class="top-right-button" type="primary" @click="openFCIMethod()">FCI</p-button>
            </div>
            <div class="card-body">
                <el-table ref="productsTable"  highlight-current-row @current-change="handleCurrentChange" v-if="products_computed.length" :data="products_computed">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Producto: {{ props.row.productLineName }}</p>
                            <p>Promedio compra: {{ setFormat(props.row.productLinePurchaseCost) }}</p>
                            <p>Frecuencia mes: {{ props.row.productLineMonthly }}</p>
                            <p>Total: {{ setFormat(props.row.productLineTotal) }}</p>
                            <el-table ref="itemsTable"  highlight-current-row @current-change="handleCurrentItemChange" v-if="props.row.items.length > 0" :data="props.row.items">
                                <el-table-column type="expand">
                                    <template slot-scope="props">
                                        <p>Precio de compra: {{ setFormat(props.row.itemPurchasePrice) }}</p>
                                        <p>Precio de venta: {{ setFormat(props.row.itemSalePrice) }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Ítem" property="itemName"></el-table-column>
                                <el-table-column label="%" property="itemPercent"></el-table-column>
                            </el-table>
                            <br>
                            <div v-if="props.row.items.length < 5">
                                <p-button 
                                    @click="addItemMethod(props.$index)"
                                    type="default" 
                                    >
                                    <i class="mr-2 fa fa-plus"></i>Agregar ítem
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="editItemMethod(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-pencil"></i>Editar ítem
                                </p-button>
                            </div>
                            <br>
                            <div v-if="currentItemRow">
                                <p-button 
                                    @click="removeItem(props.$index)"
                                    type="default" >
                                    <i class="mr-2 fa fa-minus"></i>Quitar ítem
                                </p-button>
                            </div>
                            <div class="alert alert-warning mt-2">
                                <span>Porcentaje de costo de línea: {{ Math.round(costLineAverage(props.row.items))}}%</span>
                            </div>
                            <div class="alert alert-warning mt-2">
                                <span>Costo mensual de la línea: {{ setFormat(costLineMonthly(props.row))}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Línea" property="productLineName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.productLineTotal)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="% part">
                        <template slot-scope="scope">
                            <!-- <span >{{ productPercent(scope.row.productLineTotal)}}</span> -->
                            <span >{{ scope.row.productPercent}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div>
                    <p-button 
                        @click="addProductLineMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar línea de producto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductLineMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar línea de producto
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductLineMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar línea de producto
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div v-if="products_costs_computed != 0" class="alert alert-success">
            <span>Costos mensuales: {{ setFormat(products_costs_computed)}}</span>
        </div>
        <div v-if="this.$store.state.isCustomer && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isSpouse && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales)}}</span>
        </div>
        <div v-if="this.$store.state.isGuarantor && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0" class="alert alert-success">
            <span>Ventas mensuales: {{ setFormat(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales)}}</span>
        </div>
        <div class="text-right">
            <p-button v-if="validateSwitch()" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toSalesCostsSelection()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Table, TableColumn} from 'element-ui'
    Vue.use(Table)
    Vue.use(TableColumn)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            pequenia_empresa: false,
            openFCI: false,
            pymeMessage: null,
            rowIndex: null,
            currentRow: null,
            currentItemRow: null,
            form: {
                average_selection: '',
            },
            itemName: '',
            itemPurchasePrice: '',
            itemSalePrice: '',
            itemPercent: '',
            productLineName: '',
            productLinePurchaseCost: '',
            productLinePurchaseCostFormat: '',
            productLineMonthly: '',
            productLineTotal: '',
            productLineTotalFormat: '',
            addItem: false,
            editItem: false,
            addItemIndex: null,
            items: [
                
            ],
            productName: '',
            productDaily: '',
            productWeekly: '',
            productMonthly: '',
            productValue: '',
            productMonthlyValue: '',
            productDailyCheckboxes: false,
            modelValidations: {
                average_selection: {
                    required: true
                },
                item_name: {
                    required: false
                },
                monthly: {
                    numeric: true
                }
            },
            switches: {
                daily: false,
                weekly: false,
                monthly: false,
                product: true,
                average: false,
            },
            checkboxes: [
                {
                    day: "Lunes",
                    char: "L",
                    value: false,
                    sales: ''
                },
                {
                    day: "Martes",
                    char: "M",
                    value: false,
                    sales: ''
                },
                {
                    day: "Miércoles",
                    char: "M",
                    value: false,
                    sales: ''
                },
                {
                    day: "Jueves",
                    char: "J",
                    value: false,
                    sales: ''
                },
                {
                    day: "Viernes",
                    char: "V",
                    value: false,
                    sales: ''
                },
                {
                    day: "Sábado",
                    char: "S",
                    value: false,
                    sales: ''
                },
                {
                    day: "Domingo",
                    char: "D",
                    value: false,
                    sales: ''
                },
            ],
            weeks: [
                {
                    week: '1',
                    sales: ''
                },
                {
                    week: '2',
                    sales: ''
                },
                {
                    week: '3',
                    sales: ''
                },
                {
                    week: '4',
                    sales: ''
                }
            ],
            months: [
                {
                    month: '1',
                    sales: ''
                },
                {
                    month: '2',
                    sales: ''
                },
                {
                    month: '3',
                    sales: ''
                }
            ],
            addProduct: false,
            editProduct: false,
            products: [
                
            ],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32
                },
                item_name: {
                    required: false,
                    max: 32
                },
                monthly: {
                    numeric: true
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLinePurchaseCost: function (val) {
                if (val != 0) {
                    if (this.productLineMonthly != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLineMonthly);
                        this.productLineTotalFormat = this.setFormat(this.productLineTotal);
                        this.productLinePurchaseCostFormat = this.setFormat(val);
                    }
                }
                else {
                    this.productLineTotal = 0;
                    this.productLineTotalFormat = 0;
                    this.productLinePurchaseCostFormat = 0;

                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productLineMonthly: function (val) {
                if (val != 0) {
                    if (this.productLinePurchaseCost != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLinePurchaseCost)
                    }
                }
                else {
                    this.productLineTotal = 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_computed: function (val) {
                if (this.switches.product && val > 0 && this.productDaily != 'NaN' && this.productDaily != '') {
                    this.productWeekly = parseFloat(val) * parseFloat(this.productDaily);
                }
                else if (val == 0) {
                    this.productWeekly = 0;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productDaily: function (val) {
                if (!this.switches.daily) {
                    this.productDailyCheckboxes = true;
                }
                else {
                    this.productDailyCheckboxes = false;
                }
                if (this.workdays_computed > 0 && val != 'NaN' && val != '') {
                    this.productWeekly = parseFloat(val) * this.workdays_computed;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productWeekly: function (val) {
                if (val != 'NaN' && val != '') {
                    this.productMonthly = parseFloat(val) * 4;  
                }
                else if (val != 'NaN' && val == '') {
                    this.productMonthly = '';
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthly: function (val) {
                if (this.productValue != 0 && val != '') {
                    this.productMonthlyValue = parseFloat(val) * this.productValue;
                } 
                else {
                    this.productMonthlyValue = 0;
                }  
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValue: function (val) {
                if (this.productMonthly != '' && this.productMonthly != 'NaN') {
                    this.productMonthlyValue = val * parseFloat(this.productMonthly);
                }
                else {
                    this.productMonthlyValue = 0;
                }
            }
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_computed () {
                if(this.$store.state.isCustomer) {
                    var percent = 0;
                    for (let i=0;i<this.products.length;i++) {
                        var sum = 0;
                        for (let j=0;j<this.products.length;j++) {
                            sum = sum + this.products[j].productLineTotal;
                        }
                        if (sum != 0) {
                            this.products[i].productPercent = Math.round(parseFloat(this.products[i].productLineTotal) * 100 / sum);
                        }
                        var sum_item = 0;
                        for (let k=0;k<this.products[i].items.length;k++) {
                            sum_item = sum_item + (this.products[i].items[k].itemPurchasePrice / this.products[i].items[k].itemSalePrice )*100;
                        }
                        if (this.products[i].items.length != 0) {
                            this.products[i].costLinePercent = Math.round(sum_item / this.products[i].items.length);
                        }
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                            var sum = 0;
                            var sum_item = 0;
                            var avg = 0;
                            
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            this.products[i].costLineValue =  Math.round(sum);
                        }
                        else {
                            this.products[i].costLinevalue = 0;
                        }
                    }
                    return this.products;
                }
                else if(this.$store.state.isSpouse) {
                    var percent = 0;
                    for (let i=0;i<this.products.length;i++) {
                        var sum = 0;
                        for (let j=0;j<this.products.length;j++) {
                            sum = sum + this.products[j].productLineTotal;
                        }
                        if (sum != 0) {
                            this.products[i].productPercent = Math.round(parseFloat(this.products[i].productLineTotal) * 100 / sum);
                        }
                        var sum_item = 0;
                        for (let k=0;k<this.products[i].items.length;k++) {
                            sum_item = sum_item + (this.products[i].items[k].itemPurchasePrice / this.products[i].items[k].itemSalePrice )*100;
                        }
                        if (this.products[i].items.length != 0) {
                            this.products[i].costLinePercent = Math.round(sum_item / this.products[i].items.length);
                        }
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                            var sum = 0;
                            var sum_item = 0;
                            var avg = 0;
                            
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            this.products[i].costLineValue =  Math.round(sum);
                        }
                        else {
                            this.products[i].costLinevalue = 0;
                        }
                    }
                    return this.products;
                }
                else if(this.$store.state.isGuarantor) {
                    var percent = 0;
                    for (let i=0;i<this.products.length;i++) {
                        var sum = 0;
                        for (let j=0;j<this.products.length;j++) {
                            sum = sum + this.products[j].productLineTotal;
                        }
                        if (sum != 0) {
                            this.products[i].productPercent = Math.round(parseFloat(this.products[i].productLineTotal) * 100 / sum);
                        }
                        var sum_item = 0;
                        for (let k=0;k<this.products[i].items.length;k++) {
                            sum_item = sum_item + (this.products[i].items[k].itemPurchasePrice / this.products[i].items[k].itemSalePrice )*100;
                        }
                        if (this.products[i].items.length != 0) {
                            this.products[i].costLinePercent = Math.round(sum_item / this.products[i].items.length);
                        }
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                            var sum = 0;
                            var sum_item = 0;
                            var avg = 0;
                            
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            this.products[i].costLineValue =  Math.round(sum);
                        }
                        else {
                            this.products[i].costLinevalue = 0;
                        }
                    }
                    return this.products;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            item_prices_validate_computed () {
                if (this.itemPurchasePrice <= this.itemSalePrice) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            item_percent_computed () {
                var percent = 0;
                if (this.itemPurchasePrice != 0 && this.itemSalePrice != 0) {
                    percent =  Math.round((this.itemPurchasePrice * 100) / this.itemSalePrice);
                }
                this.itemPercent = percent;
                return percent;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_costs_computed () {

                if (this.$store.state.isCustomer) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        for (let i=0;i<this.products.length;i++) {
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = sum + productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                else if(this.$store.state.isSpouse) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        for (let i=0;i<this.products.length;i++) {
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = sum + productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                if (this.$store.state.isGuarantor) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        for (let i=0;i<this.products.length;i++) {
                            if (this.products[i].items.length != 0) {
                                for (let j=0;j<this.products[i].items.length;j++) {
                                    sum_item = sum_item + (this.products[i].items[j].itemPurchasePrice / this.products[i].items[j].itemSalePrice );
                                }
                                avg = sum_item / this.products[i].items.length;
                                var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales * avg * (this.productPercentWithoutRound(this.products[i].productLineTotal) / 100))
                                sum = sum + productSum;
                                sum_item = 0;
                            }
                            else {
                                sum = 0;
                            }
                            
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            products_sales_computed () {
                var sum = 0;
                if (this.products) {
                    for (var i=0;i<this.products.length;i++) {
                        sum = sum + parseFloat(this.products[i].productLineTotal);
                    }
                }
                return sum;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_sales_computed () {
                return (this.average.good_sale + this.average.regular_sale + this.average.bad_sale) / 3;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            average_monthly_sales_computed () {
                var sum = 0;
                var total = 0;
                if (this.form.average_selection == 'diaria') {
                    return this.average_sales_computed * this.workdays_computed * 4;
                }
                else if (this.form.average_selection == 'semanal') {
                    return this.average_sales_computed * 4;
                }
                else if (this.form.average_selection == 'mensual') {
                    return this.average_sales_computed;
                }
                else {
                    return 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_computed () {
                return this.checkboxes.filter(day => day.value == true).length;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            checkboxes_computed () {
                return this.checkboxes.filter(day => day.value == true);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            workdays_sales_computed () {
                var sum = 0;
                var total = 0;
                for (var i=0; i<this.checkboxes_computed.length; i++) {
                    if (this.checkboxes_computed[i].sales != '') {
                        sum = sum + parseFloat(this.checkboxes_computed[i].sales)
                        total = sum * 4
                    }
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            weekdays_sales_computed () {
                var sum = 0;
                var total = 0;
                for (var i=0; i<this.weeks.length; i++) {
                    if (this.weeks[i].sales != '') {
                        sum = sum + parseFloat(this.weeks[i].sales)
                        total = sum
                    }
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            months_sales_computed () {
                var sum = 0;
                var avg = 0;
                for (var i=0; i<this.months.length; i++) {
                    if (this.months[i].sales != '') {
                        sum = sum + parseFloat(this.months[i].sales)
                        avg = sum / this.months.length
                    }
                }
                return avg;
            }
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setPymeCostsDescription (description) {
                this.pymeMessage = description;
                this.$store.commit('updateCustomerPECosts', description)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveCostsPymeData (description) {
                this.setPymeCostsDescription(description);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            openFCIMethod(){
                this.openFCI = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelOpenFCI(){ 
                this.openFCI = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             productValidator (product) {
                if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pequenia_empresa = true;
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentItemChange(currentRow, oldCurrentRow) {
                this.currentItemRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            costLineAverage (items) {
                var sum_item = 0;
                var avg = 0;
                if (items.length != 0) {
                    for (let j=0;j<items.length;j++) {
                        sum_item = sum_item + (items[j].itemPurchasePrice / items[j].itemSalePrice )*100;
                    }
                    avg = sum_item / items.length;
                }
                
                return avg
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            costLineMonthly (productLine) {
                if (this.$store.state.isCustomer) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        
                        if (productLine.items.length != 0) {
                            for (let j=0;j<productLine.items.length;j++) {
                                sum_item = sum_item + (productLine.items[j].itemPurchasePrice / productLine.items[j].itemSalePrice );
                            }
                            avg = sum_item / productLine.items.length;
                            var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(productLine.productLineTotal) / 100))
                            sum = productSum;
                            sum_item = 0;
                        }
                        else {
                            sum = 0;
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                else if(this.$store.state.isSpouse) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        
                        if (productLine.items.length != 0) {
                            for (let j=0;j<productLine.items.length;j++) {
                                sum_item = sum_item + (productLine.items[j].itemPurchasePrice / productLine.items[j].itemSalePrice );
                            }
                            avg = sum_item / productLine.items.length;
                            var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].minimumSales * avg * (this.productPercentWithoutRound(productLine.productLineTotal) / 100))
                            sum = productSum;
                            sum_item = 0;
                        }
                        else {
                            sum = 0;
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
                else if(this.$store.state.isGuarantor) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales != 0) {
                        var sum = 0;
                        var sum_item = 0;
                        var avg = 0;
                        
                        if (productLine.items.length != 0) {
                            for (let j=0;j<productLine.items.length;j++) {
                                sum_item = sum_item + (productLine.items[j].itemPurchasePrice / productLine.items[j].itemSalePrice );
                            }
                            avg = sum_item / productLine.items.length;
                            var productSum = (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].minimumSales * avg * (this.productPercentWithoutRound(productLine.productLineTotal) / 100))
                            sum = productSum;
                            sum_item = 0;
                        }
                        else {
                            sum = 0;
                        }
                        return Math.round(sum);
                    }
                    else {
                        return 0
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addItemIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addItem = false;
                            this.addItemIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editItemToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        var index = this.products[this.rowIndex].items.indexOf(this.currentItemRow);
                        this.products[this.rowIndex].items[index].itemName = this.itemName;
                        this.products[this.rowIndex].items[index].itemPurchasePrice = this.itemPurchasePrice;
                        this.products[this.rowIndex].items[index].itemSalePrice = this.itemSalePrice;
                        this.products[this.rowIndex].items[index].itemPercent = this.itemPercent;
                        this.resetItem();
                        this.editItem = false;
                        this.rowIndex = null;
                        this.currentItemRow = null;
                        this.$refs.itemsTable.setCurrentRow();
                        this.showNotificationSuccess('Ítem editado correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productLineName == '' || this.productLineTotal == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].productLineName = this.productLineName;
                            this.products[index].productLinePurchaseCost = this.productLinePurchaseCost;
                            this.products[index].productLinePurchaseCostFormat = this.productLinePurchaseCostFormat;
                            this.products[index].productLineMonthly = this.productLineMonthly;
                            this.products[index].productLineTotal = this.productLineTotal;
                            this.products[index].productLineTotalFormat = this.productLineTotalFormat;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.showNotificationSuccess('Producto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeItem (row) {
                this.products[row].items.splice(this.products[row].items.indexOf(this.currentItemRow),1);
                this.currentItemRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName= '',
                this.itemPurchasePrice= '',
                this.itemSalePrice= '',
                this.itemPercent= ''
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productLineName= '';
                this.productLinePurchaseCost= '';
                this.productLinePurchaseCostFormat= '';
                this.productLineMonthly= '';
                this.productLineTotal= '';
                this.productLineTotalFormat= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addItemMethod (row) {
                this.addItemIndex = row;
                this.addItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editItemMethod (row) {
                this.rowIndex = row;
                var index = this.products[row].items.indexOf(this.currentItemRow);
                this.itemName= this.products[row].items[index].itemName;
                this.itemPurchasePrice= this.products[row].items[index].itemPurchasePrice;
                this.itemSalePrice= this.products[row].items[index].itemSalePrice;
                this.itemPercent= this.products[row].items[index].itemPercent;                
                this.editItem = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditItem () {
                this.editItem = false;
                this.resetItem();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productPercent (val) {
                var sum = 0;
                var percent = 0;
                for (let i=0;i<this.products.length;i++) {
                    sum = sum + parseFloat(this.products[i].productLineTotal);
                }
                if (sum != 0) {
                    percent = Math.round(parseFloat(val) * 100 / sum);
                }
                return percent
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productPercentWithoutRound (val) {
                var sum = 0;
                var percent = 0;
                for (let i=0;i<this.products.length;i++) {
                    sum = sum + parseFloat(this.products[i].productLineTotal);
                }
                if (sum != 0) {
                    percent = parseFloat(val) * 100 / sum;
                }
                return percent
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.productName == '' || this.productMonthlyValue == 0) {
                            this.showNotificationError('El campo nombre de producto y total no pueden estar vacíos');
                        }
                        else {
                            this.products.push({
                                productName: this.productName,
                                productDaily: this.productDaily,
                                productWeekly: this.productWeekly,
                                productMonthly: this.productMonthly,
                                productValue: this.productValue,
                                productMonthlyValue: this.productMonthlyValue,
                            })
                            this.resetProduct();
                            this.addProduct = false;
                            this.showNotificationSuccess('Producto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.productName= '',
                this.productDaily= '',
                this.productWeekly= '',
                this.productMonthly= '',
                this.productValue= '',
                this.productMonthlyValue= ''
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductLineMethod () {
                this.$router.push('/asessments/new_asessment/customer/costs/business/general/add_product');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductLineMethod () {
                this.productLineName= this.currentRow.productLineName;
                this.productLinePurchaseCost= this.currentRow.productLinePurchaseCost;
                this.productLinePurchaseCostFormat= this.currentRow.productLinePurchaseCostFormat;
                this.productLineMonthly= this.currentRow.productLineMonthly;
                this.productLineTotal= this.currentRow.productLineTotal;
                this.productLineTotalFormat= this.currentRow.productLineTotalFormat;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductLineMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addMonth () {
                this.months.push({
                    month: String(this.months.length + 1),
                    sales: ''
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeMonth () {
                this.months.splice(this.months.length-1,1);
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                if(this.pequenia_empresa){
                    this.$router.push('/asessments/new_asessment/customer/pyme_general_costs_selection');
                }
                else {
                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveCosts () {
                if (this.products.length > 0) {
                    var count = 0;
                    var countPercent = 0;
                    for (let i=0;i<this.products.length;i++) {
                        if(this.products[i].productLineTotal == 0) {
                            countPercent = countPercent + 1;
                        }
                    }
                    if (countPercent != 0) {
                        this.showNotificationError('Las líneas de producto no han sido diligenciadas');
                        return
                    }
                    for (let i=0;i<this.products.length;i++) {
                        if(this.products[i].items.length == 0) {
                            count = count + 1;
                        }
                    }
                    if (count != 0) {
                        this.showNotificationError('Uno o varios productos no tienen ítems, revisa y continúa');
                        return
                    }
                }
                else {
                    this.showNotificationError('No hay productos');
                    return
                }
                this.$store.dispatch('setCostsProductLineItems', this.products).then(()=>{
                    this.$store.dispatch('setTotalCostsComputed', this.products_costs_computed).then(()=>{
                        // if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].salesPopulate == false) {
                        //     this.$router.push('/asessments/new_asessment/customer/sales');
                        // }
                        // else {
                        //     this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                        // }
                        if(this.pequenia_empresa){
                            var vm = this;
                            swal({
                                title: '¿Deseas agregar información de Salarios?',
                                // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                                text: 'Si aceptas, podrás agregar o editar la información de los Salarios',
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonText: 'Si, aceptar',
                                cancelButtonText: 'No, continuar',
                                confirmButtonClass: 'btn btn-success btn-fill',
                                cancelButtonClass: 'btn btn-danger btn-fill',
                                buttonsStyling: false
                            }).then(() => {
                                vm.$router.push('/asessments/new_asessment/customer/others/salary');
                            }, function (dismiss) {
                                // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                if (dismiss == 'cancel') {
                                    swal({
                                        title: '¿Deseas agregar información de Obligaciones Financieras?',
                                        text: 'Si aceptas, podrás agregar o editar la información de las Obligaciones Financieras',
                                        type: 'info',
                                        showCancelButton: true,
                                        confirmButtonText: 'Si, aceptar',
                                        cancelButtonText: 'No, continuar',
                                        confirmButtonClass: 'btn btn-success btn-fill',
                                        cancelButtonClass: 'btn btn-danger btn-fill',
                                        buttonsStyling: false
                                    }).then(() => {
                                        vm.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                                    }, function (dismiss) {
                                        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                                        if (dismiss == 'cancel') {
                                            vm.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                                        }
                                        else {
                                            swal({
                                                title: 'Cancelado',
                                                text: 'El analista no ha continuado',
                                                type: 'error',
                                                confirmButtonClass: 'btn btn-info btn-fill',
                                                buttonsStyling: false
                                            })
                                        }
                                    })
                                    
                                }
                                else {
                                    swal({
                                        title: 'Cancelado',
                                        text: 'El analista no ha continuado',
                                        type: 'error',
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        buttonsStyling: false
                                    })
                                }
                            })
                        }
                        else {
                            this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
                        }
                    });
                });
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].pe_costs || null;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate || this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine.length > 0) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsProductLine;
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].productType)
                    this.productValidator(product);   
                }
                if(this.pequenia_empresa){
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPymeProductLine.length > 0){
                        var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo contable de Pyme, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('resetCosts').then(()=>{
                                vm.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/pyme/general');
                        })   
                    }
                }
            }
            else if(this.$store.state.isSpouse) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].pe_costs || null;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate || this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductLine.length > 0) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsProductLine;
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].productType)
                    this.productValidator(product);
                }
                if(this.pequenia_empresa){
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPymeProductLine.length > 0){
                        var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo contable de Pyme, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('resetCosts').then(()=>{
                                vm.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/pyme/general');
                        })   
                    }
                }
            }
            else if (this.$store.state.isGuarantor) {
                this.pymeMessage = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].pe_costs || null;
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductLine.length > 0) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsProductLine;
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].productType)
                    this.productValidator(product);
                }
                if(this.pequenia_empresa){
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPymeProductLine.length > 0){
                        var vm = this;
                        swal({
                            title: '¿Estás seguro?',
                            text: 'Ya existen datos para costeo contable de Pyme, si continúa eliminará los datos anteriores',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'No, cancelar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('resetCosts').then(()=>{
                                vm.showNotificationSuccess('Los costos han sido reiniciados');
                            });
                        }, function (dismiss) {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/pyme/general');
                        })   
                    }
                }
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
    .top-right-button {
        position: absolute;
        top: 10px; /* Ajusta el espacio desde el borde superior */
        right: 10px; /* Ajusta el espacio desde el borde derecho */
    }
</style>
